module.exports = __webpack_public_path__ + "img/47-l.54f35411.png";